module.exports = {
    /**
     * Loader promise
     *
     * @type  {Promise}
     * @private
     */
    promise: null,

    /**
     * VimeoPlayer API
     *
     * @type  {VimeoPlayer}
     * @private
     */
    VimeoPlayer: null,

    /**
     * @returns  {Promise}  A promise that will resolve when the
     *                      translation is loaded.
     * @public
     */
    load: function() {
        var resolver,
            rejector;

        // Already loading or loaded
        if (this.promise) {
            return this.promise;
        }

        // New loading promise
        this.promise = new Promise(function(resolve, reject) {
            resolver = resolve;
            rejector = reject;
        });

        // Load
        require.ensure(["@vimeo/player"], function(require) {
            // Unfortunately we can't use aliases here. However, we can
            // use dynamic naming thanks to require.ensure.
            this.VimeoPlayer = require("@vimeo/player").default;
            resolver(this.VimeoPlayer);
        }, function(error) {
            rejector(error);
        }, "@vimeo/player");

        return this.promise;
    }
};
